'use client'

import { toCategoryListPage } from '@/feature/product-list/services/productList.routing'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { CATEGORY_IMAGE_SIZE_ICON } from '@/ui/media/cloudflare-picture-category/CloudflarePictureCategory'
import { CloudflarePicture } from '@/ui/media/cloudflare-picture/CloudflarePicture.client'
import { useState } from 'react'

import { Button } from '@/ui/buttons/button/Button.client'
import type { ProductListFiltersSubcategories_SubCategoriesFragment } from '@gql-generated/graphql'

import { Link } from '@/ui/links/link/Link.client'

type ValueLinkType = NonNullable<
  NonNullable<ProductListFiltersSubcategories_SubCategoriesFragment['values']>[number]
> & { __typename: 'ValueLink' }

type ReadMoreSubcategoriesLinkProps = {
  links: ValueLinkType[]
}

export function ReadMoreSubcategoriesLink({ links }: ReadMoreSubcategoriesLinkProps) {
  const { t } = useTranslation(['productListSubcategories'])
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      {isExpanded &&
        links.map((value) => (
          <Link
            variant="free"
            key={value.link.value}
            title={value.title}
            href={toCategoryListPage(value.link.value)}
            className="flex items-center gap-2"
          >
            {value.image && (
              <CloudflarePicture
                className="max-h-5 max-w-5"
                src={value.image.set?.[0]?.url}
                alt=""
                mode="contain"
                width={CATEGORY_IMAGE_SIZE_ICON}
                isInternalPicture
              />
            )}
            {t('productListSubcategories:label', {
              name: value.title,
              count: value.productCount ?? 0,
            })}
          </Link>
        ))}
      <div>
        <Button size="md" variant="link" onPress={() => setIsExpanded(!isExpanded)}>
          {isExpanded
            ? t('productListSubcategories:showLess')
            : t('productListSubcategories:showMore')}
        </Button>
      </div>
    </>
  )
}
